import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './fonts/TangerineSkies/TangerineSkiesScript-Regular.ttf'
import './fonts/TangerineSkies/TangerineSkiesSans-Regular.ttf'
import './index.css'

ReactDOM.render(
  <React.StrictMode>
    {/* <div className="app-wrapper"></div> */}
      <App />
    {/* <div/> */}
  </React.StrictMode>,
  document.getElementById('root')
);

